import React, { useState, useEffect } from 'react'
import ClientCheck from '../../system/client/ClientCheck';
import dayjs from 'dayjs';
import { Form, Radio, Table, } from 'antd';
import ReportCheck from './ReportCheck';    
import classes from './report.module.css';
import Icon from '../../cpn/Icon';
import StateTag from '../../cpn/StateTag';
function ReportListNeedRead(props) {
    const [form] = Form.useForm();
    const [list, setList] = useState(props.spList);
    const [query, setQuery] = useState({
        dsbzd_state: '',
    });
    useEffect(() => {
        let arr = props.spList.filter((item) => (item.dsbzd_sp_state === '2' || item.dsbzd_sp_state === '3') && item.dsbzd_sp_jd_name === '抄送');
        if(query.dsbzd_state){
            arr = arr.filter((item) => item.dsbzd_sp_state === query.dsbzd_state);
        }
        const unread = arr.filter(item => item.dsbzd_sp_state === '2');
        const read = arr.filter(item => item.dsbzd_sp_state === '3');
        read.sort((a, b) => new Date(b.dsbzd_sp_state_time) - new Date(a.dsbzd_sp_state_time));
        const sortedArr = [...unread, ...read];
        setList(sortedArr);
    }, [props.spList, query.dsbzd_state]);
    const columns = [
        {
            key: 'dsbzd_sp_state',
            dataIndex: 'dsbzd_sp_state',
            title: "",
            width: '1%',
            render: (_, record) => {
                if(record.dsbzd_sp_state === '2'){
                    return <Icon type='needRead' />
                }
                return <Icon type='readed' />
            },
        },
        {
            title: '团队名称',
            dataIndex: 'dsbzd_sp_dsbzd_name',
            key: 'dsbzd_sp_dsbzd_name',
            width: "20%",
            render: (_, record) =>  <ReportCheck 
                                        dsbzd_id={record.dsbzd_sp_dsbzd_id} 
                                        dsbzd_name={record.dsbzd_sp_dsbzd_name} 
                                        dsbzd_date={record.dsbzd_sp_dsbzd_date}
                                        dsbzd_date_end={record.dsbzd_sp_dsbzd_date_end}
                                        dsbzd_kh_id={record.dsbzd_sp_dsbzd_kh_id}
                                        dsbzd_kh_name={record.dsbzd_sp_dsbzd_kh_name}
                                        yh_id={props.yh_id}  
                                        yh_name={props.yh_name} 
                                        qy_id={props.qy_id} 
                                        qy_name={props.qy_name}
                                        dsbzd_sp_id={record.dsbzd_sp_id}
                                        dsbzd_sp_jd_xuhao={record.dsbzd_sp_jd_xuhao}
                                        dsbzd_sp_yh_id={record.dsbzd_sp_yh_id}
                                        dsbzd_sp_yh_name={record.dsbzd_sp_yh_name}
                                        dsbzd_sp_uid={props.yh_id}
                                        dsbzd_sp_uname={props.yh_name}
                                        dsbzd_sp_jd_name={record.dsbzd_sp_jd_name}
                                        dsbzd_sp_state={record.dsbzd_sp_state}
                                        needRead={record.dsbzd_sp_state === '2'}
                                    />
        },
        {
            key: 'dsbzd_sp_dsbzd_date',
            dataIndex: 'dsbzd_sp_dsbzd_date',
            title: "开始日期",
            width: "6%",            
        },
        {
            key: 'dsbzd_sp_dsbzd_date_end',
            dataIndex: 'dsbzd_sp_dsbzd_date_end',
            title: "结束日期",
            width: "6%",
        },
        {
            key: 'dsbzd_sp_dsbzd_date_end',
            dataIndex: 'dsbzd_sp_dsbzd_date_end',
            title: "天数",
            width: "3%",
            render: (_, record) => <>{dayjs(record.dsbzd_date_end).diff(dayjs(record.dsbzd_date), 'day') + 1}</>,
        },
      
        {
            key: 'dsbzd_sp_dsbzd_kh_name',
            dataIndex: 'dsbzd_sp_dsbzd_kh_name',
            title: "客户",
            width: "8%",
            render: (text, record) => <ClientCheck kh_id={record.dsbzd_sp_dsbzd_kh_id} kh_name={record.dsbzd_sp_dsbzd_kh_name} qy_id={props.qy_id} qy_name={props.qy_name} yh_id={props.yh_id} yh_name={props.yh_name} />
        },
        {
            key: 'dsbzd_sp_uname',
            dataIndex: 'dsbzd_sp_uname',
            title: "提交人",
            width: "8%",
            render: (text, record) => <>{record.dsbzd_sp_uname} {record.dsbzd_sp_ctime}</>,
        },
        {
            key: 'dsbzd_sp_state_time',
            dataIndex: 'dsbzd_sp_state_time',
            title: "阅读时间",
            width: "8%",            
        },
        {
            title: '状态',
            dataIndex: 'dsbzd_sp_state',
            width: '5%',
            key: 'dsbzd_sp_state',            
            render:(text) => <StateTag state={text} />
        },     
        {
            key: 'dsbzd_sp_dsbzd_id',
            dataIndex: 'dsbzd_sp_dsbzd_id',
            title: "编号",    
            width: "4%",   
        },
    ]
    return (
        <>
            <div>
                <Form 
                    form={form} 
                    layout="inline" 
                    name="form_need_read" 
                    onFinish={(values) => {
                       
                    }}
                    labelCol={{ span: 3 }}
                    initialValues={{dsbzd_state:''}}
                >
                    <Form.Item 
                        name='dsbzd_state' 
                        label={props.label} 
                        required={props.required} 
                        style={props.style} 
                        wrapperCol={props.wrapperCol}
                        noStyle    
                    >
                        <Radio.Group 
                            onChange={(e) => {
                                setQuery(prev => ({ 
                                    ...prev, 
                                    dsbzd_state: e.target.value, 
                                }));
                                localStorage.setItem('jtg-caiwu_reportList_dsbzd_state', JSON.stringify(e.target.value));
                            }}
                            buttonStyle='solid'
                            optionType="button" 
                        >
                            <Radio value='' >全部</Radio>
                            <Radio value='2' >未读</Radio>
                            <Radio value='3' >已读</Radio>                
                        </Radio.Group>        
                    </Form.Item>
                </Form>
            </div>
            <Table 
                className={classes.customTable}
                dataSource={list} 
                columns={columns} 
                rowKey='dsbzd_sp_id'
                locale={{
                    emptyText: '暂无团队报账单' // This will display text when the table is empty
                }}
                size='small'
                bordered
                style={{ marginTop: '10px' }}
                pagination={{
                    pageSize: 50,
                    pageSizeOptions: [10, 20, 50, 100],
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => `共 ${total} 条`,
                    onChange: (page, pageSize) => {
                        console.log(page, pageSize);
                    }
                }}
            />

        </>
    )
}

export default ReportListNeedRead